import ConfiguratorMetaobject from '../../Interfaces/ConfiguratorMetaobject';
import ShapeInterface from '../../Interfaces/ShapeInterface';
import Shape from '../Fields/Shape';
import Message from '../Fields/Message';
import Dimensions from '../Fields/Dimensions';
import { ErrorMessage, useFormikContext } from 'formik';
import { howToMeasure, sectionSettings, icons, selectedConfiguratorModel } from '../../Helpers/WindowHelpers';
import Heading from '../Heading';
import Modal from '../Fields/ModalSection';
import BonusContent from '../Fields/BonusContent';
import Checkbox from '../Fields/Checkbox';
import { useEffect } from 'react';
import parse from 'html-react-parser';

interface Step2Interface {
    shapes: ShapeInterface[],
    metaobject: ConfiguratorMetaobject
}

const Step2 = ({ shapes, metaobject }: Step2Interface) => {
    const { values, errors, touched, isSubmitting } = useFormikContext<any>();
    const shapeObject = shapes.find(shape => shape.shape_id === values.shape);
    const presetShapeId = selectedConfiguratorModel?._shape
        ? `${selectedConfiguratorModel._shape}${metaobject.rolling_covers ? "_Rolling" : ''}`.replaceAll(' ', '_')
        : null;
    const displayedShapes = presetShapeId
        ? shapes.filter((shape) => shape.shape_id === presetShapeId)
        : shapes;
    const presetModelLocked = !!presetShapeId;
    useEffect(() => {
        const errorKeys = Object.keys(errors);

        if (!!errorKeys.length) {
            const firstAvailableElementId = errorKeys.find((key) => document.querySelector(`#${key}`) as HTMLElement)
            if (!firstAvailableElementId) return;
            const firstElement = document.querySelector(`#${firstAvailableElementId}`) as HTMLElement;
            if (firstElement !== document.activeElement) {
                firstElement.focus();
                firstElement.scrollIntoView({ behavior: "smooth", inline: "nearest" });
            }
        }
    }, [isSubmitting]);

    return (
        <>
            <Heading
                level={4}
                text={metaobject.text.shape_heading}
            >
                {values.shape &&
                    <span className="d--flex align-items--center gap-5">
                        {sectionSettings.label_shape}:
                        <span className="configurator-selected__selected">
                            {shapes.find(item => item.shape_id == values.shape)?.name}
                        </span>
                    </span>
                }
            </Heading>
            <div className="configurator-shapes">
                {
                    (displayedShapes ?? []).map((shape, index) => (
                        <Shape shape={shape} key={index} disabled={presetModelLocked} />
                    ))
                }
            </div>
            <ErrorMessage component={"div"} name={"shape"} className={"configurator-content__error rte links-underline"}></ErrorMessage>
            {metaobject.text.custom_checkbox_text
                ? <Checkbox name={"customFeatures"} >
                    {parse(metaobject.text.custom_checkbox_text ?? '')}
                    </Checkbox>
                : <div className="rte links-underline">{parse(metaobject.text.custom_callout ?? '')}</div>}

            {shapeObject?.shape_warning
                ? <Message message={shapeObject?.shape_warning} isWarning={true} additionalClasses="mb-20" />
                : null}

            <Heading
                level={4}
                text={sectionSettings.label_dimensions}
            />
            {metaobject.text.measuring_help && howToMeasure.name !== ""
                ? <Modal
                    classes={"d--flex gap-4 align-items--center"}
                    buttonBody={`${icons.info} ${metaobject.text.measuring_help}`}
                >
                    <BonusContent
                        title={sectionSettings.label_how_to_measure}
                        content={howToMeasure}
                    ></BonusContent>
                </Modal>
                : null
            }
            <Dimensions
                shapes={shapes}
            />
            {values.customShape
                ? <Message message={metaobject.text.custom_shape_oversize_warning} isSmall={true} additionalClasses="mb-20" />
                : <Checkbox name="attestation" text={metaobject.text.dimensions_attestation} error={(errors["attestation"] && touched["attestation"]) == true} />}
        </>
    )
}

export default Step2;
